// import React, { useState, useEffect, useCallback } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   FiPackage, FiFileText, FiRefreshCw, FiAlertCircle,
//   FiSearch, FiChevronLeft, FiChevronRight,
// } from 'react-icons/fi';
// import { getGoodsReceipts, getInvoiceReceipts } from '../../utils/grirApi';

// /* ── helpers ── */
// const fmt = (str) =>
//   str
//     ? new Date(str).toLocaleDateString('en-GB', {
//         day: '2-digit', month: 'short', year: 'numeric',
//       })
//     : '—';

// const fmtAmt = (val) =>
//   val !== undefined && val !== null
//     ? Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//     : '—';

// /* ── motion variants ── */
// const rowVariants = {
//   hidden:  { opacity: 0, y: 10 },
//   visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 220, damping: 26 } },
// };
// const tableVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.04 } } };

// const PAGE_SIZE = 15;

// /* ══════════════════════════════════════════════════════════
//    GENERIC RECEIPT TABLE
//    ══════════════════════════════════════════════════════════ */
// const ReceiptTable = ({ type }) => {
//   const isGR = type === 'gr';
//   const [rows, setRows]       = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError]     = useState('');
//   const [search, setSearch]   = useState('');
//   const [page, setPage]       = useState(1);

//   const load = useCallback(() => {
//     setLoading(true);
//     setError('');
//     const fetcher = isGR ? getGoodsReceipts : getInvoiceReceipts;
//     fetcher({ limit: 200 })
//       .then((data) => {
//         const arr = Array.isArray(data) ? data : (data.items ?? data.results ?? []);
//         setRows(arr);
//         setPage(1);
//       })
//       .catch((err) => setError(err.message))
//       .finally(() => setLoading(false));
//   }, [isGR]);

//   useEffect(() => { load(); }, [load]);

//   /* ── derived filtered/paged rows ── */
//   const filtered = rows.filter((r) => {
//     if (!search.trim()) return true;
//     return JSON.stringify(r).toLowerCase().includes(search.toLowerCase());
//   });
//   const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
//   const paged = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

//   const handleSearch = (e) => { setSearch(e.target.value); setPage(1); };

//   /* ── derive column keys from first row ── */
//   const columns = rows.length > 0 ? Object.keys(rows[0]) : [];

//   /* ── column label prettifier ── */
//   const colLabel = (key) =>
//     key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

//   /* ── value renderer ── */
//   const renderCell = (val, key) => {
//     if (val === null || val === undefined) return <span className="grir-muted">—</span>;
//     if (typeof val === 'boolean') return val ? '✓' : '✗';
//     if (key.toLowerCase().includes('amount') || key.toLowerCase().includes('price')) return fmtAmt(val);
//     if (key.toLowerCase().includes('date')) return fmt(val);
//     if (typeof val === 'object') return JSON.stringify(val);
//     return String(val);
//   };

//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
//       {/* Search bar + Refresh */}
//       <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//         <div className="grir-search-wrap" style={{ flex: 1, position: 'relative' }}>
//           <FiSearch size={14} style={{
//             position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
//             color: 'var(--g-muted)', pointerEvents: 'none',
//           }} />
//           <input
//             className="grir-input"
//             style={{ paddingLeft: 34 }}
//             placeholder={`Search ${isGR ? 'goods receipts' : 'invoice receipts'}…`}
//             value={search}
//             onChange={handleSearch}
//           />
//         </div>
//         <motion.button
//           className="grir-icon-btn"
//           onClick={load}
//           title="Refresh"
//           whileTap={{ rotate: 180 }}
//           transition={{ duration: 0.4 }}
//           disabled={loading}
//         >
//           <FiRefreshCw size={14} style={{ color: loading ? 'var(--g-muted)' : 'var(--gp)' }} />
//         </motion.button>
//       </div>

//       <AnimatePresence>
//         {error && (
//           <motion.div
//             key="err"
//             className="grir-feedback error"
//             initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
//           >
//             <FiAlertCircle size={13} /> {error}
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {loading ? (
//         <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Loading…</span></div>
//       ) : rows.length === 0 ? (
//         <div className="grir-empty">No {isGR ? 'goods receipts' : 'invoice receipts'} found.</div>
//       ) : (
//         <>
//           <div className="grir-table-wrap">
//             <table className="grir-table">
//               <thead>
//                 <tr>
//                   {columns.map((col) => (
//                     <th key={col}>{colLabel(col)}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <motion.tbody variants={tableVariants} initial="hidden" animate="visible">
//                 {paged.length === 0 ? (
//                   <tr>
//                     <td colSpan={columns.length} style={{ textAlign: 'center', padding: '24px', color: 'var(--g-muted)' }}>
//                       No results match your search.
//                     </td>
//                   </tr>
//                 ) : (
//                   paged.map((row, i) => (
//                     <motion.tr key={row.id ?? i} variants={rowVariants}>
//                       {columns.map((col) => (
//                         <td key={col}>{renderCell(row[col], col)}</td>
//                       ))}
//                     </motion.tr>
//                   ))
//                 )}
//               </motion.tbody>
//             </table>
//           </div>

//           {/* ── Pagination ── */}
//           {totalPages > 1 && (
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, marginTop: 4 }}>
//               <span style={{ fontSize: 12, color: 'var(--g-muted)' }}>
//                 {filtered.length} record{filtered.length !== 1 ? 's' : ''} · Page {page} of {totalPages}
//               </span>
//               <motion.button
//                 className="grir-icon-btn"
//                 onClick={() => setPage((p) => Math.max(1, p - 1))}
//                 disabled={page === 1}
//                 whileTap={{ scale: 0.88 }}
//               >
//                 <FiChevronLeft size={14} />
//               </motion.button>
//               <motion.button
//                 className="grir-icon-btn"
//                 onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
//                 disabled={page === totalPages}
//                 whileTap={{ scale: 0.88 }}
//               >
//                 <FiChevronRight size={14} />
//               </motion.button>
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// /* ══════════════════════════════════════════════════════════
//    MAIN COMPONENT — sub-tabs GR | IR
//    ══════════════════════════════════════════════════════════ */
// const SUB_TABS = [
//   { id: 'gr', label: 'Goods Receipts',   icon: <FiPackage  size={13} /> },
//   { id: 'ir', label: 'Invoice Receipts', icon: <FiFileText size={13} /> },
// ];

// const subTabVariants = {
//   initial:  { opacity: 0, y: 10 },
//   animate:  { opacity: 1, y: 0, transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] } },
//   exit:     { opacity: 0, y: -8, transition: { duration: 0.18, ease: 'easeIn' } },
// };

// const GRIRReceipts = () => {
//   const [sub, setSub] = useState('gr');

//   return (
//     <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: '0 0 32px' }}>
//       {/* ── Sub-tab bar ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div style={{ display: 'flex', gap: 6 }}>
//             {SUB_TABS.map((t) => (
//               <motion.button
//                 key={t.id}
//                 className={`grir-subtab-btn${sub === t.id ? ' active' : ''}`}
//                 onClick={() => setSub(t.id)}
//                 whileTap={{ scale: 0.96 }}
//                 style={{
//                   display: 'flex', alignItems: 'center', gap: 6,
//                   padding: '7px 16px', borderRadius: 8, border: 'none',
//                   cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 500,
//                   background: sub === t.id ? 'var(--g-grad)' : 'var(--g-bg)',
//                   color: sub === t.id ? '#fff' : 'var(--g-muted)',
//                   boxShadow: sub === t.id ? '0 2px 10px rgba(91,95,199,0.25)' : 'none',
//                   transition: 'all 0.22s ease',
//                 }}
//               >
//                 {t.icon}
//                 {t.label}
//               </motion.button>
//             ))}
//           </div>
//         </div>

//         <div style={{ padding: '0 20px 20px' }}>
//           <AnimatePresence mode="wait">
//             <motion.div
//               key={sub}
//               variants={subTabVariants}
//               initial="initial"
//               animate="animate"
//               exit="exit"
//             >
//               <ReceiptTable type={sub} />
//             </motion.div>
//           </AnimatePresence>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default GRIRReceipts;



import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FiPackage, FiFileText, FiRefreshCw, FiAlertCircle,
  FiSearch, FiChevronLeft, FiChevronRight,
} from 'react-icons/fi';
import { useGrirApi } from './GrirApiContext';

/* ── helpers ── */
const fmt = (str) =>
  str
    ? new Date(str).toLocaleDateString('en-GB', {
        day: '2-digit', month: 'short', year: 'numeric',
      })
    : '—';

const fmtAmt = (val) =>
  val !== undefined && val !== null
    ? Number(val).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '—';

/* ── motion variants ── */
const rowVariants = {
  hidden:  { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 220, damping: 26 } },
};
const tableVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.04 } } };

const PAGE_SIZE = 15;

/* ══════════════════════════════════════════════════════════
   GENERIC RECEIPT TABLE
   ══════════════════════════════════════════════════════════ */
const ReceiptTable = ({ type }) => {
  const { getGoodsReceipts, getInvoiceReceipts } = useGrirApi();
  const isGR = type === 'gr';
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [search, setSearch]   = useState('');
  const [page, setPage]       = useState(1);

  const load = useCallback(() => {
    setLoading(true);
    setError('');
    const fetcher = isGR ? getGoodsReceipts : getInvoiceReceipts;
    fetcher({ limit: 200 })
      .then((data) => {
        const arr = Array.isArray(data) ? data : (data.items ?? data.results ?? []);
        setRows(arr);
        setPage(1);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [isGR]);

  useEffect(() => { load(); }, [load]);

  /* ── derived filtered/paged rows ── */
  const filtered = rows.filter((r) => {
    if (!search.trim()) return true;
    return JSON.stringify(r).toLowerCase().includes(search.toLowerCase());
  });
  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const paged = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleSearch = (e) => { setSearch(e.target.value); setPage(1); };

  /* ── derive column keys from first row ── */
  const columns = rows.length > 0 ? Object.keys(rows[0]) : [];

  /* ── column label prettifier ── */
  const colLabel = (key) =>
    key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  /* ── value renderer ── */
  const renderCell = (val, key) => {
    if (val === null || val === undefined) return <span className="grir-muted">—</span>;
    if (typeof val === 'boolean') return val ? '✓' : '✗';
    if (key.toLowerCase().includes('amount') || key.toLowerCase().includes('price')) return fmtAmt(val);
    if (key.toLowerCase().includes('date')) return fmt(val);
    if (typeof val === 'object') return JSON.stringify(val);
    return String(val);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      {/* Search bar + Refresh */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div className="grir-search-wrap" style={{ flex: 1, position: 'relative' }}>
          <FiSearch size={14} style={{
            position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)',
            color: 'var(--g-muted)', pointerEvents: 'none',
          }} />
          <input
            className="grir-input"
            style={{ paddingLeft: 34 }}
            placeholder={`Search ${isGR ? 'goods receipts' : 'invoice receipts'}…`}
            value={search}
            onChange={handleSearch}
          />
        </div>
        <motion.button
          className="grir-icon-btn"
          onClick={load}
          title="Refresh"
          whileTap={{ rotate: 180 }}
          transition={{ duration: 0.4 }}
          disabled={loading}
        >
          <FiRefreshCw size={14} style={{ color: loading ? 'var(--g-muted)' : 'var(--gp)' }} />
        </motion.button>
      </div>

      <AnimatePresence>
        {error && (
          <motion.div
            key="err"
            className="grir-feedback error"
            initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
          >
            <FiAlertCircle size={13} /> {error}
          </motion.div>
        )}
      </AnimatePresence>

      {loading ? (
        <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Loading…</span></div>
      ) : rows.length === 0 ? (
        <div className="grir-empty">No {isGR ? 'goods receipts' : 'invoice receipts'} found.</div>
      ) : (
        <>
          <div className="grir-table-wrap">
            <table className="grir-table">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th key={col}>{colLabel(col)}</th>
                  ))}
                </tr>
              </thead>
              <motion.tbody variants={tableVariants} initial="hidden" animate="visible">
                {paged.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length} style={{ textAlign: 'center', padding: '24px', color: 'var(--g-muted)' }}>
                      No results match your search.
                    </td>
                  </tr>
                ) : (
                  paged.map((row, i) => (
                    <motion.tr key={row.id ?? i} variants={rowVariants}>
                      {columns.map((col) => (
                        <td key={col}>{renderCell(row[col], col)}</td>
                      ))}
                    </motion.tr>
                  ))
                )}
              </motion.tbody>
            </table>
          </div>

          {/* ── Pagination ── */}
          {totalPages > 1 && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8, marginTop: 4 }}>
              <span style={{ fontSize: 12, color: 'var(--g-muted)' }}>
                {filtered.length} record{filtered.length !== 1 ? 's' : ''} · Page {page} of {totalPages}
              </span>
              <motion.button
                className="grir-icon-btn"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
                whileTap={{ scale: 0.88 }}
              >
                <FiChevronLeft size={14} />
              </motion.button>
              <motion.button
                className="grir-icon-btn"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
                whileTap={{ scale: 0.88 }}
              >
                <FiChevronRight size={14} />
              </motion.button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   MAIN COMPONENT — sub-tabs GR | IR
   ══════════════════════════════════════════════════════════ */
const SUB_TABS = [
  { id: 'gr', label: 'Goods Receipts',   icon: <FiPackage  size={13} /> },
  { id: 'ir', label: 'Invoice Receipts', icon: <FiFileText size={13} /> },
];

const subTabVariants = {
  initial:  { opacity: 0, y: 10 },
  animate:  { opacity: 1, y: 0, transition: { duration: 0.28, ease: [0.22, 1, 0.36, 1] } },
  exit:     { opacity: 0, y: -8, transition: { duration: 0.18, ease: 'easeIn' } },
};

const GRIRReceipts = () => {
  const [sub, setSub] = useState('gr');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: '0 0 32px' }}>
      {/* ── Sub-tab bar ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div style={{ display: 'flex', gap: 6 }}>
            {SUB_TABS.map((t) => (
              <motion.button
                key={t.id}
                className={`grir-subtab-btn${sub === t.id ? ' active' : ''}`}
                onClick={() => setSub(t.id)}
                whileTap={{ scale: 0.96 }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '7px 16px', borderRadius: 8, border: 'none',
                  cursor: 'pointer', fontFamily: 'inherit', fontSize: 13, fontWeight: 500,
                  background: sub === t.id ? 'var(--g-grad)' : 'var(--g-bg)',
                  color: sub === t.id ? '#fff' : 'var(--g-muted)',
                  boxShadow: sub === t.id ? '0 2px 10px rgba(91,95,199,0.25)' : 'none',
                  transition: 'all 0.22s ease',
                }}
              >
                {t.icon}
                {t.label}
              </motion.button>
            ))}
          </div>
        </div>

        <div style={{ padding: '0 20px 20px' }}>
          <AnimatePresence mode="wait">
            <motion.div
              key={sub}
              variants={subTabVariants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <ReceiptTable type={sub} />
            </motion.div>
          </AnimatePresence>
        </div>
      </motion.div>
    </div>
  );
};

export default GRIRReceipts;
